export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'left',
    width: 80,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_development_date') || '开发日期',
    field: 'bizDate',
    align: 'center',
    width: 170,
    editRender: {
      name: 'ElDatePicker',
      props: {
        placeholder: that.$l('INDEX.tips_select_date') || '选择日期',
        type: 'date',
        'value-format': 'yyyy-MM-dd',
        style: 'width: 100%',
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_fabric_information') || '面料信息',
    field: 'fabricInfo',
    align: 'left',
    minWidth: 240,
    slots: { default: 'fabricInfo' },
  },
  {
    title: that.$l('INDEX.choose_fabric_wid_and_weight') || '门幅/克重',
    field: 'widAndWeight',
    width: 100,
    align: 'left',
    slots: { default: 'widAndWeight' }
  },
  {
    title: that.$l('INDEX.form_label_color') || '颜色',
    field: 'fabricColorTitle',
    headerAlign: 'center',
    align: 'left',
    minWidth: 260,
  },
  {
    field: 'unitPrice',
    minWidth: 120,
    title: that.$l('INDEX.choose_fabric_price') || '单价',
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'requestQuantity',
    minWidth: 150,
    title: that.$l('INDEX.quantity') || '数量',
    headerAlign: 'center',
    align: 'center',
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 999999.99,
        step: 0.01,
        'controls-position': 'right',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    field: 'fabricUnit',
    minWidth: 120,
    title: that.$l('table_label_fabricUnit') || '单位',
    headerAlign: 'center',
    align: 'center',
    editRender: {
      name: 'dict-select',
      props: {
        body: { dictType: 'fabricYarnUnit' },
        url: '/digitalCenter/common/dict/biz',
        filterable: true,
        clearable: true,
        size: "mini"
      },
    },
  },

  {
    title: that.$l('table_label_fabricAmount') || '面料金额',
    field: 'requestAmount',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    isTotalColumn: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 99999999.99,
        step: 0.01,
        'controls-position': 'right',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    field: 'requestFee',
    minWidth: 150,
    title: that.$l('table_label_requestFee') || '附加费',
    headerAlign: 'center',
    align: 'center',
    isTotalColumn: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 999999999.99,
        step: 0.01,
        'controls-position': 'right',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_currencyAmount') || '费用合计',
    field: 'currencyAmount',
    align: 'center',
    width: 120,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_billCount') || '单据张数',
    field: 'billCount',
    align: 'center',
    width: 130,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 0,
        min: 0,
        max: 1000000000,
        step: 1,
        'controls-position': 'right',
      },
    },
    isTotalColumn: true,
  },
  {
    title: that.$l('form_label_expenseType') || '费用项目',
    field: 'expenseType',
    align: 'left',
    headerAlign: 'center',
    minWidth: 200,
    editRender: {
      name: 'dict-select',
      props: {
        body: { dictType: 'expenseType' },
        url: '/master/common/dict/biz',
        filterable: true,
        clearable: true,
        size: "mini"
      },
    },
  },
  {
    title: that.$l('item_label_custCode') || '客户',
    field: 'custName',
    align: 'left',
    headerAlign: 'center',
    minWidth: 250,
    editRender: { enable: true },
    slots: { edit: 'customer' },
  },
  {
    title: that.$l('item_label_custOrderNo') || '客户订单号',
    field: 'custOrderNo',
    align: 'left',
    headerAlign: 'center',
    minWidth: 250,
    editRender: { enable: true },
    slots: { edit: 'custOrderNo' },
  },
  {
    title: that.$l('table_label_brand') || '品牌',
    field: 'brandCode',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    editRender: {
      name: 'dict-select',
      props: {
        url: '/master/common/dict/brandSelect',
        filterable: true,
        clearable: true,
        size: 'mini',
        placeholder: that.$l('table_label_please_select_brand') || '请选择品牌',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('item_label_orgDepFullName') || '分摊部门',
    field: 'orgDepFullName',
    align: 'left',
    headerAlign: 'center',
    minWidth: 300,
    editRender: { enable: true },
    slots: { edit: 'depCode' },
  },
]
